import { styled } from "goober";
import { config } from "../../environment";
import { isAdminViewUrl } from "../../lib/adminViewUrls";
import { publicUrl } from "../../lib/tenantOrigin";
import { lastVisitedLocation } from "../../lib/urls";
import { Backdrop } from "../Backdrop";
import { Box } from "../Box";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { SettingsSidebar } from "./SettingsSidebar";

const Content = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
`;

const SpaceBadge = styled("span")`
  margin-left: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 8px 0 6px;
  height: 20px;
  background: var(--alpha4);
  border-radius: 38px;
  color: var(--text-secondary);
`;

type Props = {
  children: React.ReactNode;
};

export function SettingsLayout({ children }: Props) {
  const from = lastVisitedLocation(
    (url) => !url.startsWith("/settings") && !isAdminViewUrl(url)
  );
  const externalPublicUrl = publicUrl();
  const spaceName = (() => {
    try {
      return new URL(externalPublicUrl).hostname;
    } catch {
      return externalPublicUrl;
    }
  })();

  return (
    <>
      <title>{`Settings • ${config.title}`}</title>
      <Backdrop
        permanentNavigation
        overrideLogo={<Icon name="arrow-left" size={16} />}
        logoHref={from ?? "/"}
        navigation={<SettingsSidebar />}
        afterPath={
          <>
            <Box horizontal={4} vertical={8} center>
              <Text variant="text-regular-md">Settings</Text>
            </Box>
            <SpaceBadge>
              <Icon name="building-2" size={10} />
              <Text variant="text-small-md" ellipsis style={{ maxWidth: 220 }}>
                {spaceName}
              </Text>
            </SpaceBadge>
          </>
        }
      >
        <Content>{children}</Content>
      </Backdrop>
    </>
  );
}
